import { Check, Languages } from "lucide-react";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { LANGS } from "../lib/i18n";
import { api } from "../lib/api";

const SHORT = { nb: "BM", nn: "NN" };

// «Språkval»: Bokmål / Nynorsk. Innlogget arrangør får valget lagret på kontoen (følger med til e-poster).
export const LanguageToggle = ({ className = "", compact = false }) => {
  const { lang, setLang, t } = useLang();
  const auth = useAuth();

  const choose = (l) => {
    if (l === lang) return;
    setLang(l);
    if (auth?.organizer) {
      api.patch("/auth/me/lang", { lang: l }).catch(() => {});
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`text-muted-foreground hover:text-foreground ${compact ? "px-2" : "px-2.5"} ${className}`}
          aria-label={t("Språkvalg")}
          title={t("Språkvalg")}
          data-testid="language-toggle"
        >
          <Languages className="w-4 h-4" aria-hidden="true" />
          {compact ? (
            // Kompakt (dashbord-toppmeny): alltid kortkode så menyen ikke blir bredere enn plassen
            <span className="ml-1 text-xs font-medium" data-testid="language-toggle-label" title={LANGS[lang]}>
              {SHORT[lang]}
            </span>
          ) : (
            <>
              <span className="hidden sm:inline ml-1.5" data-testid="language-toggle-label">
                {LANGS[lang]}
              </span>
              <span className="sm:hidden ml-1 text-xs font-medium" aria-hidden="true">
                {SHORT[lang]}
              </span>
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" data-testid="language-menu">
        <DropdownMenuLabel className="text-xs text-muted-foreground font-normal uppercase tracking-wide">{t("Språkvalg")}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {Object.entries(LANGS).map(([code, label]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => choose(code)}
            className="cursor-pointer justify-between"
            data-testid={`language-option-${code}`}
            data-selected={code === lang ? "true" : "false"}
          >
            <span>{label}</span>
            {code === lang && <Check className="w-4 h-4 text-brand" aria-hidden="true" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
